import { SAGE_FAILURE } from '../../datahub/sage/sageApi';

const FAILURE_MESSAGE_IDS = {
  [SAGE_FAILURE.MISSING_SAGE_ID]: 'sage.everify.needsOnboard',
  [SAGE_FAILURE.NOT_FOUND]: 'sage.error.notACandidate',
  [SAGE_FAILURE.UNAVAILABLE]: 'sage.error.unavailable',
  [SAGE_FAILURE.UNKNOWN]: 'sage.error.generic',
};

// The route can name a document type the dictionary has no label for, so the raw type is
// the fallback rather than a missing-translation marker.
export const formatDocumentTypes = (intl, documentTypes = []) =>
  documentTypes
    .map((documentType) => {
      const id = `sage.documentType.${documentType}`;
      return intl.messages?.[id] ? intl.formatMessage({ id }) : documentType;
    })
    .join(' and ');

export const failureMessage = (intl, failure) => {
  if (!failure) {
    return null;
  }
  if (failure.kind === SAGE_FAILURE.MISSING_DOCUMENTS) {
    return intl.formatMessage(
      { id: 'sage.onboard.missingDocuments' },
      { documents: formatDocumentTypes(intl, failure.missingDocumentTypes) }
    );
  }
  // 400 from payroll is a flat, server-worded message; show it against the form as sent.
  if (failure.kind === SAGE_FAILURE.INVALID_REQUEST) {
    return failure.message || intl.formatMessage({ id: 'sage.error.generic' });
  }
  return intl.formatMessage({ id: FAILURE_MESSAGE_IDS[failure.kind] || 'sage.error.generic' });
};

export const everifyMessage = (intl, { status, caseNumber }) =>
  caseNumber
    ? intl.formatMessage({ id: 'sage.everify.statusWithCase' }, { status, caseNumber })
    : intl.formatMessage({ id: 'sage.everify.status' }, { status });

// `sage` is the only machine-written verifier; a manually entered case records a person's
// name, so anything without a label falls back to the stored value.
export const everifyVerifierLabel = (intl, eVerifier) => {
  if (!eVerifier) {
    return null;
  }
  const id = `sage.everify.verifier.${eVerifier}`;
  return intl.messages?.[id] ? intl.formatMessage({ id }) : eVerifier;
};
